import { Minus, Plus } from 'lucide-react'
import { cn } from '../lib/cn.js'
import { Icone } from './Icone.js'

export function QuantityStepper({
  valor,
  onMudar,
  min = 1,
  max = 50,
  className,
}: {
  valor: number
  onMudar: (v: number) => void
  min?: number | undefined
  max?: number | undefined
  className?: string | undefined
}) {
  return (
    <span className={cn('du-passo', className)}>
      <button
        type="button"
        className="du-passo__botao"
        onClick={() => onMudar(Math.max(min, valor - 1))}
        disabled={valor <= min}
        aria-label="Diminuir quantidade"
      >
        <Icone de={Minus} tamanho={20} />
      </button>
      {/* aria-live para o leitor de tela anunciar a mudança sem precisar focar */}
      <output className="du-passo__valor" aria-live="polite">
        {valor}
      </output>
      <button
        type="button"
        className="du-passo__botao"
        onClick={() => onMudar(Math.min(max, valor + 1))}
        disabled={valor >= max}
        aria-label="Aumentar quantidade"
      >
        <Icone de={Plus} tamanho={20} />
      </button>
    </span>
  )
}
